import { Link } from "react-router-dom";
import { Siren, Search, HandHeart, MapPinned } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { CategoryBanner } from "./CategoryBanner";

const ReportButtons = () => {
  const { t } = useLanguage();
  return (
    <div className="flex flex-wrap gap-2">
      <Link to="/post?category=lost-found&lf=lost" data-testid="lf-report-lost-btn" className="inline-flex items-center gap-2 h-11 px-5 rounded-xl bg-red-600 hover:bg-red-700 text-white font-semibold text-sm transition-colors">
        <Search size={16} /> {t("lf_report_lost")}
      </Link>
      <Link to="/post?category=lost-found&lf=found" data-testid="lf-report-found-btn" className="inline-flex items-center gap-2 h-11 px-5 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white font-semibold text-sm transition-colors">
        <HandHeart size={16} /> {t("lf_report_found")}
      </Link>
      <Link to="/lost-found/map" data-testid="lf-map-btn" className="inline-flex items-center gap-2 h-11 px-5 rounded-xl bg-white hover:bg-slate-100 text-[#12234A] border border-slate-200 font-semibold text-sm transition-colors">
        <MapPinned size={16} /> {t("lmap_view_map")}
      </Link>
    </div>
  );
};

const DefaultAlert = () => {
  const { t } = useLanguage();
  return (
    <section data-testid="lf-default-header" className="mt-4 relative overflow-hidden rounded-2xl bg-[#12234A] text-white">
      <div className="absolute inset-y-0 left-0 w-2 bg-red-600" />
      <div className="absolute -right-10 -top-10 h-48 w-48 rounded-full bg-red-600/20 blur-3xl" />
      <div className="relative px-6 sm:px-10 py-7 flex flex-col md:flex-row md:items-center gap-5">
        <span className="h-14 w-14 shrink-0 rounded-2xl bg-red-600 flex items-center justify-center animate-pulse">
          <Siren size={28} />
        </span>
        <div className="flex-1">
          <h1 className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight">{t("lf_title")}</h1>
          <p className="text-slate-300 mt-1 text-sm sm:text-base max-w-2xl">{t("lf_sub")}</p>
        </div>
        <ReportButtons />
      </div>
    </section>
  );
};

// Admin-managed banner (Marketing → scope "Lost & Found"); falls back to a built-in alert header.
export const LostFoundHeader = () => (
  <CategoryBanner category="lost-found" hero fallback={<DefaultAlert />}>
    <div className="mt-3 flex justify-end"><ReportButtons /></div>
  </CategoryBanner>
);

export const LostFoundTabs = ({ value, onChange }) => {
  const { t } = useLanguage();
  const tabs = [
    { id: "all", label: t("lf_all"), cls: "bg-[#12234A]" },
    { id: "lost", label: t("lf_tab_lost"), cls: "bg-red-600" },
    { id: "found", label: t("lf_tab_found"), cls: "bg-emerald-600" },
    { id: "reunited", label: t("lf_tab_reunited"), cls: "bg-teal-500" },
  ];
  return (
    <div className="mt-5 inline-flex flex-wrap bg-white rounded-xl border border-slate-200 p-1 gap-1" data-testid="lf-tabs">
      {tabs.map((x) => (
        <button key={x.id} onClick={() => onChange(x.id)} data-testid={`lf-tab-${x.id}`}
          className={`px-4 h-9 rounded-lg text-sm font-semibold transition-colors ${value === x.id ? `${x.cls} text-white` : "text-slate-600 hover:bg-slate-50"}`}>
          {x.label}
        </button>
      ))}
    </div>
  );
};
